@use "../styles/typography" as *;

.root {
  position: relative;
  display: inline-flex;
}

.menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: var(
    --chartv2-surface-raised,
    var(--surface-default, var(--background-default, #222))
  );
  border: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(255, 255, 255, 8%)));
  border-radius: 8px;
  box-shadow: var(--elevation-moderate, 0 2px 8px rgba(0, 0, 0, 30%));
  padding: 1px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 100%;
  max-height: 500px;
  overflow: hidden auto;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin: 8px 8px 0;
  border-radius: 4px;
  @include body-sm;
  color: var(--chartv2-foreground, var(--text-default, #eee));
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  box-sizing: border-box;
  white-space: nowrap;
}

.item:last-child {
  margin-bottom: 8px;
}

.item:hover,
.item.focused {
  background: var(
    --chartv2-chip-hover,
    var(--surface-hover, rgba(255, 255, 255, 8%))
  );
}

/* Full-bleed so the 4px accent bar sits flush against the menu edge,
 * mirroring the design system's `DropdownListItem`. */
.item.active {
  margin-left: 0;
  margin-right: 0;
  padding-left: 16px;
  background: var(
    --chartv2-chip-active,
    var(--surface-active, rgba(255, 255, 255, 12%))
  );
}

.item.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 36px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 4px;
  background-color: var(--chartv2-primary, var(--border-primary, #ffc53d));
}

.item.disabled {
  color: var(--text-disabled, #6e6e6e);
  cursor: not-allowed;
  pointer-events: none;
}

/* Drawn in the row gap rather than as the row's own border so the line
 * spans the whole menu (v1 borders the `li`, not the inset row). */
.item.separated::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -8px;
  right: -8px;
  border-top: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(255, 255, 255, 8%)));
}

.item.active.separated::after {
  left: 0;
  right: 0;
}
